export const GUEST_PARKING = 'service_lpr_external';
